import styled, { css } from 'styled-components';
import { flexCenterVertical } from '@stylesheets/helpers';

// =============================================================================
// Layout — full-page with landing-style background
// =============================================================================

export const Page = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${({ theme: { colors, font } }) => css`
    background: ${colors?.surfaceContainerLowest};
    color: ${colors?.onSurface};
    font-family: ${font?.bodyLarge?.fontFamily}, -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
  `}

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
`;

export const Background = styled.div`
  position: absolute;
  inset: 0;
  background: url('/img/landing/landing-background.png') center center / cover no-repeat;
  opacity: 0.65;
  filter: brightness(0.6) saturate(0.2);

  ${({ theme: { colors } }) => css`
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(
        ellipse at 50% 50%,
        transparent 20%,
        ${colors?.surfaceContainerLowest} 90%
      );
    }
  `}
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ theme: { spacing } }) => css`
    padding: ${spacing?.level6} ${spacing?.level6} 0;
  `}

  @media (max-width: 768px) {
    height: auto;
    overflow-y: visible;

    ${({ theme: { spacing } }) => css`
      padding: ${spacing?.level5} ${spacing?.level4} 0;
    `}
  }
`;

// =============================================================================
// Logo — reuses Login's Logo + BrandName (imported in .tsx)
// =============================================================================

export const LogoHeader = styled.div`
  ${flexCenterVertical}

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level3};
    margin-bottom: ${spacing?.level6};
  `}
`;

// =============================================================================
// Logout link
// =============================================================================

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level3};
    margin: ${spacing?.level6} auto ${spacing?.level6};
  `}
`;

export const LogoutLink = styled.button`
  ${({ theme: { font, colors } }) => css`
    background: none;
    border: none;
    ${font?.labelLarge}
    color: ${colors?.primary};
    cursor: pointer;
    text-decoration: none;

    &:hover,
    &:focus {
      opacity: 0.75;
    }
  `}
`;

export const DialogError = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    ${font?.bodyMedium}
    color: ${colors?.error ?? '#FF6B6B'};
    margin: ${spacing?.level3} 0 0;
  `}
`;

export const ReturnToPersonalLink = styled.button`
  ${({ theme: { font, colors } }) => css`
    background: none;
    border: none;
    ${font?.labelLarge}
    color: ${colors?.primary};
    cursor: pointer;
    text-decoration: none;

    &:hover,
    &:focus {
      opacity: 0.75;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`;
